module.exports = __webpack_public_path__ + "img/upstairs.8471d787.png";